var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function validateAllowedFileType(fileType, allowedTypes, fileName) {
    // if types are not specified - assume all are allowed
    if (allowedTypes.length == 0)
        return true;
    // extension entries ('.rpt', '.csv') match against the file name — needed for
    // formats that have no standard MIME type (browsers report '' for them)
    const extensions = allowedTypes.filter(t => t.startsWith('.'));
    if (fileName && extensions.some(ext => fileName.toLowerCase().endsWith(ext.toLowerCase()))) {
        return true;
    }
    const mimeTypes = allowedTypes.filter(t => !t.startsWith('.'));
    if (mimeTypes.length == 0)
        return false;
    // check if file type is allowed
    let isAllowed = mimeTypes.find(t => t == fileType);
    if (isAllowed)
        return true;
    // get base type
    let [base, type] = fileType.split("/");
    // find in allowed types based on base type
    let allowed = mimeTypes.filter(t => t.startsWith(base));
    if (allowed.length == 0)
        return false;
    // check if all subtypes are allowed
    let allowedAll = allowed.find(t => t == [base, "*"].join("/"));
    return allowedAll != undefined;
}
export function blobToDataUrl(blob) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((done, nope) => {
            let fileReader = new FileReader();
            fileReader.onload = done;
            fileReader.readAsDataURL(blob);
        })
            .then((e) => e.target.result);
    });
}
